import { useNavigate, Link } from "react-router-dom";
import { PROFILE_IMG_BASE } from "@config/env";
import DashboardSectionCard from "./DashboardSectionCard";
import EmptyState from "./EmptyState";
import AvailabilityRing from "@common/AvailabilityRing";

const timeAgo = (d) => {
  if (!d) return "";
  const diff = Math.floor((Date.now() - new Date(d.replace(/-/g, "/"))) / 1000);
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff/60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff/3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff/86400)}d ago`;
  return new Date(d.replace(/-/g, "/")).toLocaleDateString("en-US", { month:"short", day:"numeric" });
};

const fmtDate = (d) => {
  if (!d) return "";
  return new Date(d.replace(/-/g, "/")).toLocaleDateString("en-US", { month:"short", day:"numeric", year:"numeric" });
};

export default function RecentUpdates({ updates = [], loading }) {
  const navigate = useNavigate();

  return (
    <DashboardSectionCard title="Recent Updates" subtitle="Latest availability changes" icon="fa-clock-rotate-left" colorKey="cyan"
      action={updates.length > 0
        ? <Link to="/availability-updates" style={{fontSize:12,fontWeight:600,color:"var(--fc-primary)",textDecoration:"none"}}>View all &rarr;</Link>
        : null}>
      {loading ? (
        <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
          {[1,2,3].map(i => (
            <div key={i} style={{ background:"var(--fc-bg-light)", borderRadius:10, padding:"11px 13px", display:"flex", gap:12, alignItems:"center" }}>
              <div style={{ width:38, height:38, borderRadius:99, background:"var(--fc-border-light)", flexShrink:0 }} />
              <div style={{ flex:1 }}>
                <div style={{ height:12, background:"var(--fc-border-light)", borderRadius:4, width:"55%", marginBottom:6 }} />
                <div style={{ height:10, background:"var(--fc-border-light)", borderRadius:4, width:"35%" }} />
              </div>
            </div>
          ))}
        </div>
      ) : !updates.length ? (
        <EmptyState icon="fa-clock-rotate-left" text="No recent updates" sub="Availability changes will show up here" />
      ) : (
        <div className="fc-scroll-container" style={{ overflowY:"auto", overflowX:"hidden", maxHeight:280, scrollbarWidth:"none" }}>
          <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
            {updates.map((u, i) => (
              <div key={u.user_slug || i}
                onClick={() => navigate(`/resources/details/${u.user_slug}`)}
                style={{ background:"var(--fc-bg-light)", border:"1px solid var(--fc-border-light)", borderRadius:10, padding:"11px 13px", cursor:"pointer", transition:"all 0.15s", display:"flex", alignItems:"center", gap:12 }}
                onMouseEnter={e=>{ e.currentTarget.style.background="var(--fc-cyan-light)"; e.currentTarget.style.borderColor="var(--fc-cyan-border)"; }}
                onMouseLeave={e=>{ e.currentTarget.style.background="var(--fc-bg-light)"; e.currentTarget.style.borderColor="var(--fc-border-light)"; }}>

                {/* Avatar */}
                <div style={{ width:38, height:38, borderRadius:99, background:"var(--fc-border-light)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, overflow:"hidden" }}>
                  {u.profile_image_path
                    ? <img src={PROFILE_IMG_BASE + u.profile_image_path} alt="" style={{ width:"100%", height:"100%", objectFit:"cover" }} onError={e=>e.target.style.display="none"} />
                    : <i className="fa-solid fa-user" style={{ fontSize:12, color:"var(--fc-text-subtle)" }} />
                  }
                </div>

                {/* Info */}
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontSize:13, fontWeight:600, color:"var(--fc-text-primary)", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", marginBottom:3 }}>
                    {u.resource_name}
                  </div>
                  <div style={{ fontSize:11, color:"var(--fc-text-subtle)", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                    {u.updated_by_name ? `Updated by ${u.updated_by_name}` : "Availability updated"} · {fmtDate(u.updated_at)} ({timeAgo(u.updated_at)})
                  </div>
                </div>

                {/* Availability ring */}
                {u.availability != null && (
                  <AvailabilityRing value={u.availability} size={34} />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </DashboardSectionCard>
  );
}
